import { Size } from '@vivli/shared/theme';
import { CSSProperties, useMemo } from 'react';

interface AdminHeaderProps {
    style?: CSSProperties;
    children?: any;
    direction?: 'vertical' | 'horizontal';
    isCustomHeaderVisible?: boolean;
    styleHasColumns?: boolean;
}

export const AdminHeaderView = ({
    style,
    children,
    direction = 'vertical',
    isCustomHeaderVisible = false,
    styleHasColumns = false,
}: AdminHeaderProps) => {
    const innerStyle = useMemo(() => {
        const baseStyle = {
            marginBottom: Size.SMALL_INSET_SIZE,
            marginLeft: Size.INSET_SIZE,
            marginRight: Size.INSET_SIZE,
            marginTop: Size.TOP_INSET_SIZE,
            display: 'grid',
            '@media print': {
                display: 'none',
            },
            ...style,
        } as CSSProperties;

        switch (direction) {
            case 'vertical':
                return {
                    ...baseStyle,
                    gridTemplateRows: isCustomHeaderVisible ? 'auto 1fr' : 'auto',
                    rowGap: '20px',
                };
            case 'horizontal':
                if (style && styleHasColumns) {
                    return {
                        ...baseStyle,
                        gridTemplateColumns: isCustomHeaderVisible ? '1fr auto' : 'auto',
                        columnGap: '20px',
                        ...style,
                    };
                }
                return {
                    ...baseStyle,
                    gridTemplateColumns: isCustomHeaderVisible ? 'minmax(350px,1fr) auto' : 'auto',
                    columnGap: '20px',
                };
        }
    }, [direction, style]);

    return <div style={innerStyle}>{children}</div>;
};
